type Positionable = { position: number }

export default function sotByPosition<T extends Positionable>(list: T[]) {
  return list.slice().sort((a, b) => a.position - b.position)
}
